<template>
    <div class="img_canvas">
        <div class=" ">
            <div v-for="item, index in list" :key="index"  class="list">
                <el-row>
                    <el-col :span="8" ><div class="item-l"> <img :src="getImgSrc(item)" alt=""> </div></el-col>
                    <el-col :span="16" >
                        <div class="item-r">
                            <div class="title line1">{{item.title}}</div>
                            <div class="line2" style="font-size:none">
                            <span class="content"  v-html="replaceImg(item.content)"></span>
                            </div>
                            <div class="item-b">
                                <div class="time">{{item.showDate?item.showDate.substring(0,10):''}}</div>
                                <div class="link"  @click="handleDetail(item.docId)">
                                    <span class="link-text">查看详情</span>
                                    <img class="link-img"  src="../../assets/images/newHome/jiantao.png" alt="">
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>         
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'img-info-list',
    props:{
        list: {
            type: Array,
            default: () => ([]),
        },
    },
    data () {
        return {}
    },
    methods: {
        handleDetail(val){
            this.$emit('handleDetail', val)
        },
        // 获取图片地址
        getImgSrc(info){
            let srcSource = null
            let imgInfo
            if (typeof info.content === "string") {
                srcSource = info.content.match(/src="([^"]*)"/g);
            }
            if (srcSource) {
                let imgList = srcSource[0].split('src=')
                imgInfo = imgList[1].replace("\"","").replace("\"","")
            }
            return imgInfo
        },
        replaceImg(info) {
            if (info) {
                let content
                content = info.replace(/<img .*?>/g,"");//去除图片在列表中显示
                return content
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import './XFour.scss'

</style>
